import Header from "../../Components/Header"
import React from 'react'
import PecaPlastica1 from "../../imagens/pecasplasticas/PecaPlastica1.png"
import PecaPlastica2 from "../../imagens/pecasplasticas/PecaPlastica2.png"
import PecaPlastica3 from "../../imagens/pecasplasticas/PecaPlastica3.png"
import PecaPlastica4 from "../../imagens/pecasplasticas/PecaPlastica4.png"
import PecaPlastica5 from "../../imagens/pecasplasticas/PecaPlastica5.png"
import PecaPlastica6 from "../../imagens/pecasplasticas/PecaPlastica6.png"
import PecaPlastica7 from "../../imagens/pecasplasticas/PecaPlastica7.png"
import PecaPlastica8 from "../../imagens/pecasplasticas/PecaPlastica8.png"
import PecaPlastica9 from "../../imagens/pecasplasticas/PecaPlastica9.png"
import PecaPlastica10 from "../../imagens/pecasplasticas/PecaPlastica10.png"
import PecaPlastica11 from "../../imagens/pecasplasticas/PecaPlastica11.png"
import PecaPlastica12 from "../../imagens/pecasplasticas/PecaPlastica12.png"
import PecaPlastica13 from "../../imagens/pecasplasticas/PecaPlastica13.png"
import PecaPlastica14 from "../../imagens/pecasplasticas/PecaPlastica14.png"
import PecaPlastica15 from "../../imagens/pecasplasticas/PecaPlastica15.png"
import PecaPlastica16 from "../../imagens/pecasplasticas/PecaPlastica16.png"
import PecaPlastica17 from "../../imagens/pecasplasticas/PecaPlastica17.png"
import ImgPlasticos from "../../Components/imgplasticosCapabilities"




const listaPecaPlastica = [
  {
    img: PecaPlastica1
  },
  {
    img: PecaPlastica2
  },
  {
    img: PecaPlastica3
  },
  {
    img: PecaPlastica4
  },
  {
    img: PecaPlastica5
  },
  {
    img: PecaPlastica6
  },
  {
    img: PecaPlastica7
  },
  {
    img: PecaPlastica8
  },
  {
    img: PecaPlastica9
  },
  {
    img: PecaPlastica10
  },
  {
    img: PecaPlastica11
  },
  {
    img: PecaPlastica12
  },
  {
    img: PecaPlastica13
  },
  {
    img: PecaPlastica14
  },
  {
    img: PecaPlastica15
  },
  {
    img: PecaPlastica16
  },
  {
    img: PecaPlastica17
  },

]

function PlasticCapabilitesPage() {
  return (
    <div>
      <Header></Header>

      <ImgPlasticos
        listaPecaPlastica={listaPecaPlastica}
      />
    </div>
  )
}

export default PlasticCapabilitesPage